import { Stack, Typography } from '@mui/material';
import HighchartsReact from 'highcharts-react-official';
import Highcharts from 'highcharts';
import {
  SplineChartOptionsProps,
  splineChartOptions,
} from '../../subdomains/visitation/configuration/splineChartOptions';
import { formatters } from '@utils/formattersV2';
import {
  DifferenceChip,
  DifferenceChipProps,
} from '../../subdomains/visitation/components/Summary/SummaryView/DifferenceChip';
import '../../styles/spline_chart.scss';
import {
  ChartTitle,
  ChartTitleProps,
} from '../../subdomains/visitation/components/Summary/SummaryView/Charts/ChartTitle';
import { ConfidenceLevel } from '../ConfidenceLevel';

export type SplineChartWithHeaderProps = SplineChartOptionsProps & {
  title: ChartTitleProps['title'];
  differenceType: 'standard' | 'lift';
  confidenceLevel?: number;
  tooltipTitle?: ChartTitleProps['tooltipTitle'];
  ['data-testid']?: string;
};

export const SplineChartWithHeader = (props: SplineChartWithHeaderProps) => {
  const { title, confidenceLevel, tooltipTitle, ...splinechartOptionsProps } =
    props;

  const latestValue = splinechartOptionsProps.data.at(-1)?.value ?? 0;
  const previousValue = splinechartOptionsProps.data.at(-2)?.value ?? 0;
  const difference = latestValue - previousValue;
  const differenceFormatter: DifferenceChipProps['formatter'] =
    props.differenceType === 'standard'
      ? value => formatters.number(value, { full: true })
      : value => formatters.percentage(value, { decimals: 1 });

  return (
    <Stack
      direction="column"
      gap="1rem"
      flexGrow={1}
      flexBasis={0}
      data-testid={props['data-testid']}
    >
      <ChartTitle title={title} tooltipTitle={tooltipTitle} />
      <Stack direction="row" gap="0.5rem" alignItems="center">
        <Typography fontSize="h4.fontSize" fontWeight="bold">
          {splinechartOptionsProps.formatter?.(latestValue) ?? latestValue}
        </Typography>

        <ConfidenceLevel value={confidenceLevel} lift={latestValue} />

        <DifferenceChip
          difference={difference}
          formatter={differenceFormatter}
        />
      </Stack>

      <HighchartsReact
        highcharts={Highcharts}
        options={splineChartOptions(splinechartOptionsProps)}
        containerProps={{
          className: props.data.length > 1 ? 'spline-chart' : '',
        }}
      />
    </Stack>
  );
};
